import { useEffect, useState } from "react";

const AttributeSection = ({ sectionValues, attribute, handleMouseOverEvent, handleMouseOutEvent, handleClickPageEvent, sectionStyle }) => {
    
    const [items, setItems] = useState([]);

    const extractSectionNumber = (section) => {
        return Array.isArray(section) ? getPageFromOcrDiv(Object.keys(section[0])[0]) : section;
    }

    function getPageFromOcrDiv(divId) {
        return divId.split('_')[1];
    }

    const generateSectionForDiv = (section, index) => {
        return `${section}.${index}`;
    }

    const getOcrDivIds = (section) => {
        // if a section value is stored as an array, it would be the latest updated OCR div ids
        return Array.isArray(section) ? section : null;
    }

    useEffect(() => {
        setItems(sectionValues ? Array.isArray(sectionValues) ? sectionValues : [sectionValues] : []);
    }, [sectionValues]);
    
    return (
        <div style={{ display: 'inline-flex'}}>
            Section(s):
            <div style={{display: 'flex', overflowX: 'auto', width: items.length > 1 ? '60px': '35px'}}>
                {items?.map((section, index) => (
                    <button
                        key={index}
                        style={sectionStyle}
                        aria-label={`Navigate to page ${extractSectionNumber(section)}`}
                        onMouseOver={() => handleMouseOverEvent(attribute, generateSectionForDiv(section, index), getOcrDivIds(section))}
                        onMouseOut={() => handleMouseOutEvent(attribute, generateSectionForDiv(section, index), getOcrDivIds(section))}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClickPageEvent(attribute, generateSectionForDiv(section, index), getOcrDivIds(section));
                        }}
                    >
                        {extractSectionNumber(section)}&nbsp;
                    </button>))}
            </div>
        </div>
    );
}

export default AttributeSection;